// extracted by mini-css-extract-plugin
module.exports = {"container":"e_rq","lang":"e_sq","pre":"e_tq","code":"e_uq","button":"e_vq"};